import { Icon } from '@99designs/common/components/Icon';
import { Tooltip } from '@99designs/common/components/Tooltip';
import React from 'react';

interface Props {}

export default class GenerativeAiTooltip extends React.Component<Props> {
    render() {
        return (
            <Tooltip
                position={'up-center'}
                tooltip={
                    <div className={'generative-ai-tooltip'}>
                        {__(
                            '99designs allows the use of generative AI (artificial intelligence) tools when creating designs for this contest, but only if you give your permission.'
                        )}
                    </div>
                }
            >
                <span className="tooltip-trigger">
                    <Icon type={'question-mark-1'} variations={['offset-left']} />
                </span>
            </Tooltip>
        );
    }
}
